/* eslint-disable eqeqeq */
import {
  Box,
  Button,
  Flex,
  FormLabel,
  Heading,
  Icon,
  Input,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import * as Yup from "yup";

import { useState } from "react";
import { BiLowVision, BiShow } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { ResetpasswordAction } from "../../../modules/auth/Actions";
import PublicLayout from "../../public/Layout/layout";
const ChangepasswordForm = ({ withTitle }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.auth.isLoading);
  const [inputType, setInputType] = useState("password");
  const userId = localStorage.getItem("userID");
  const token = localStorage.getItem("token");

  const forgetpasswordSchema = Yup.object().shape({
    new_password: Yup.string().required("Required"),
  });

  const formik = useFormik({
    initialValues: {},
    validationSchema: forgetpasswordSchema,
    validateOnChange: true,
    onSubmit: (values) => {
      dispatch(
        ResetpasswordAction({
          ...values,
          user_id: userId,
          token,
        })
      );
    },
  });
  const errorStyle = (isValid) =>
    isValid == "Required" ? "red !important" : "#0100108 !important";

  return (
    <PublicLayout color="main_1" bg="white" register={true}>
      <Flex
        bg="whiteAlpha.700"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        my="150px"
        w="100%"
        h="100%"
        dir="rtl"
      >
        <div style={{ width: "40%" }}>
          <div style={{ width: "100%" }}>
            <form onSubmit={formik.handleSubmit}>
              <Flex
                flexDirection="column"
                w="100%"
                gap={8}
                fontFamily="sans-serif"
              >
                {withTitle && (
                  <Heading textAlign={"center"} mb="10px">
                    اختار كلمة مرور جديدة
                  </Heading>
                )}
                <Box position={"relative"} w="100%">
                  <Flex alignItems={"center"}>
                    <FormLabel
                      htmlFor="new_password"
                      className="form-label "
                      color="main_1"
                      fontSize="22px"
                      fontWeight="500"
                    >
                      كلمة المرور
                    </FormLabel>
                  </Flex>

                  <Input
                    style={{
                      padding: "10px",
                      objectFit: "contain",
                      borderRadius: "10px",
                      boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
                      backgroundColor: "#fff",
                      color: "black",
                      width: "100%",
                    }}
                    borderColor={errorStyle(formik?.errors.new_password)}
                    name="new_password"
                    onChange={formik.handleChange}
                    value={formik.values.new_password}
                    type={inputType}
                  />

                  <Icon
                    position={"absolute"}
                    left="10px"
                    top="45px"
                    fontSize="33px"
                    color="main_1"
                    as={inputType == "password" ? BiShow : BiLowVision}
                    onClick={() =>
                      inputType == "password"
                        ? setInputType("text")
                        : setInputType("password")
                    }
                  />
                </Box>

                <Button
                  type="submit"
                  w="250px"
                  p="22px"
                  alignSelf={"center"}
                  isLoading={isLoading}
                  bg="main_1"
                  color="white"
                >
                  حفظ
                </Button>
              </Flex>
            </form>
          </div>
        </div>
      </Flex>
    </PublicLayout>
  );
};

export default ChangepasswordForm;
